function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m73.6 78 21.3 21.3L76.4 118l-10.7-10.7L73.6 78Z",
  fill: "#EAEEF4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M104.7 26.6 79.5 51.8 54 26.2m60.8 10.5L89.7 62l8.7 8.7 25.2-25.1M45.4 34.8 71 60.3l-6.3 6.3L39 41.1m-6.7 6.3L62 76.1l-5 22.3-38.6-38.6m62.8 10.7 39 39m11.4-56.2-25.2 25.2 22.4 22.4m-16.1 16-9.5-9.4L67 143.7m-8.2-8.2 9.5-9.4-10.7-10.7L48 125m-8.8-8.8 9.4-9.4-27-27.1-9.5 9.4m61.4-11 21.3 21.3L76.4 118l-10.7-10.7L73.6 78Z",
  stroke: "#BEC7D6"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 91.6,
  cy: 113.4,
  r: 30.6,
  fill: "#00BAFF",
  fillOpacity: 0.2
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#a)",
  transform: "rotate(-90 91.4 113.6)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 91.4,
  cy: 113.6,
  r: 6.1,
  fill: "#00BAFF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91.4,
  cy: 113.6,
  r: 4.8,
  stroke: "#fff",
  strokeWidth: 2.7
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M104 119.4a6 6 0 0 0-6.2 6.2c0 2.5 2 5.3 5.7 8.6.3.3.7.3 1 0 3.7-3.3 5.6-6.1 5.6-8.6a6 6 0 0 0-6.1-6.2Zm0 7.6c-.9 0-1.6-.7-1.6-1.5s.7-1.5 1.6-1.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5Z",
  fill: "#FF6562"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "a",
  x: 12,
  y: 46.4,
  width: 158.8,
  height: 161.5,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 10.9,
  operator: "dilate",
  in: "SourceAlpha",
  result: "effect1_dropShadow_1016_17719"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 12.2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 31.2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.282353 0 0 0 0 0.309804 0 0 0 0 0.372549 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1016_17719"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 4.1,
  operator: "dilate",
  in: "SourceAlpha",
  result: "effect2_dropShadow_1016_17719"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 32.6
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 25.8
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.623529 0 0 0 0 0.670588 0 0 0 0 0.733333 0 0 0 0.03 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_1016_17719",
  result: "effect2_dropShadow_1016_17719"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 9.5,
  in: "SourceAlpha",
  result: "effect3_dropShadow_1016_17719"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 14.9
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10.2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.745098 0 0 0 0 0.780392 0 0 0 0 0.839216 0 0 0 0.02 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect2_dropShadow_1016_17719",
  result: "effect3_dropShadow_1016_17719"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect3_dropShadow_1016_17719",
  result: "shape"
})));

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 170,
    width: 170,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 171 208",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.4e6a648a.svg";
export { ForwardRef as ReactComponent };